<script setup>
import { useTemplateRef, onMounted, ref, provide, shallowRef, computed } from 'vue'
import { useApi } from '@provise/composables/api'
import SimpleSchema from '@/components/simpleSchema.vue'
import { useMessageStack } from '@provise/stores/messagestack'

const emit = defineEmits(['save'])
const doc = defineModel()
const props = defineProps({
  apiFn: {
    type: Function,
    required: true,
  },
})

const { push: notify } = useMessageStack()
const docTemplates = ref([])

const { model: emailTemplates } = useApi({
  url: 'email_templates',
  immediate: true,
  pick: d => d.data || [],
  data: [],
})
const emailTemlateSelectOptions = computed(() =>
  emailTemplates.value.reduce((memo, t) => {
    memo[t.name] = t.id
    return memo
  }, {})
)
const docSch = [
  ['text', 'name', 'Укажите название файла', { required: 1 }],
  ['select-id', 'doc_template', 'Укажите бланк документа', { options: docTemplates }],
  [
    'h5',
    null,
    null,
    {
      layout: false,
      text: 'Введите текст, который будет напечатан на бланке',
      class: 'mb-0 g-full',
    },
  ],
  [
    'select',
    null,
    'Использовать шаблон',
    {
      options: emailTemlateSelectOptions,
      'onUpdate:modelValue': onEmailTemplateSelected,
    },
  ],
  ['editor', 'doc_text', null, { layout: 'g-full', rows: 3 }],
  ['textarea', 'comment', 'Комментарий', { rows: 3, layout: 'g-full' }],
]
useApi({ url: 'doc_templates', model: docTemplates, immediate: true, pick: d => d.data || [] })

async function createDocument() {
  if (doc.value.doc_text && !doc.value.doc_template) {
    notify('Выберите бланк')
    return
  }
  const isNew = !doc.value.id
  await props.apiFn()
  notify(isNew ? 'Ответ создан' : 'Ответ изменён')
  emit('save')
}

const frm = useTemplateRef('doc-form')

onMounted(() => {
  frm.value.scrollIntoView({ behavior: 'smooth' })
})
provide('form:editable', shallowRef(true))

function onEmailTemplateSelected(_id) {
  const tpl = emailTemplates.value.find(({ id }) => id == _id)
  if (!tpl) {
    return
  }
  doc.value = { ...doc.value, doc_text: tpl.text }
}
</script>
<template>
  <form @submit.prevent="createDocument" ref="doc-form">
    <div class="form-schema mb-3">
      <SimpleSchema v-model="doc" :simplsch="docSch" />
    </div>

    <button class="btn btn-success" type="submit" v-if="doc.id">
      <i class="bi bi-check" />
      Сохранить
    </button>
    <button type="submit" class="btn btn-warning" v-else>
      <i class="bi bi-check-square me-1" />
      Создать новый документ и добавить его в «Ответы»
    </button>
  </form>
</template>
